function App() {
  return (
    <h1
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      Hey there! My name is Amir
    </h1>
  );
}

export default App;
